/* Interface 
    intrf
*/
export interface INTRFAddress{
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
}

interface INTRFCategor{
  groupid: string;
  parent_id: string | null;
  name: string;
  description: string;
}

export interface INTRFUser{
    username: string;
    name: string;
    firstname?: string;
    lastname?: string;
    loggedin: boolean;
    address: INTRFAddress;
    
}

export function AppUser(): INTRFUser {
    return {username: "", name: "", loggedin: false, address: {address1: "", address2: "", city: "", state:"",zip:""}}
}


export interface INTRFItem{
    itemid: string;
    name: string;
    price: number;
    image: string; /* URL */
    rating: string;
    description: string;
    size: number; 
}

export function AppItem(): INTRFItem {
    return {
        itemid: "",
        name: "",
        price: 0,
        image: "", /* URL */
        rating: "",
        description: "",
        size: 0,
    }
    
}